/**
 * canonical を出さないパス。
 *
 * **検索結果はクエリで中身が変わる**ので代表URLを持たせない。`route.path` だけを見ると
 * `/search?q=ラフィーネ` の canonical が `/search`（＝クエリなしの0件ページ）になり、
 * noindex と「別URLを指す canonical」を同時に出すことになる（Google が矛盾シグナルとして扱う）。
 */
const CANONICAL_EXCLUDED_PATHS: string[] = ['/search'];

export const useCanonical = () => {
  const { frontDomain } = useRuntimeConfig().public;
  const canonicalUrlState = useState<string | null>('canonicalUrlState', () => frontDomain);

  const getCanonicalPath = (url: string): string => {
    switch (url) {
      case '/products/558':
        return '/products/559';
      case '/products/K43':
      case '/products/K44':
      case '/products/K45':
        return '/products/K42';
      default:
        return url;
    }
  };

  const setCanonicalUrlState = (url: string): void => {
    canonicalUrlState.value = CANONICAL_EXCLUDED_PATHS.includes(url)
      ? null
      : new URL(getCanonicalPath(url), frontDomain).href;
  };

  return {
    canonicalUrlState: readonly(canonicalUrlState),
    setCanonicalUrlState,
  };
};
